import React, { Fragment } from 'react'
import * as progressStyles from '../../styles/project-modules/bills/progress.module.less'
import {
  updated_bill_steps,
  passed,
  vetoed,
  origCommittee,
  nonOrigCommittee
} from '../../data/LegisTracker_all_states_text.json'
import SafeLink from '../sfc/safelink'
import chamberNames from '../../data/sfc/chamber_names.json'

function Progress({
  bill,
  minimal = false,
  MARKET_KEY
}) {

  //svgs used in table, with custom classes for styling
  const arrow_svg = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.06 95.37" preserveAspectRatio="none" width="100%" height="100%"><polyline class=${progressStyles.triangle} points="27.03 25.37 38.06 12.69 27.03 0"/><polyline class=${progressStyles.line} points="0 94.87 13.79 94.87 13.79 12.69 29.23 12.69"/></svg>`;
  const further_review_arrow_svg = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38.1 25.4" preserveAspectRatio="none" width="100%" height="100%"><polyline class=${progressStyles.triangle} points="27,25.4 38.1,12.7 27,0 "/><line class=${progressStyles.line} x1="0" y1="12.7" x2="29.2" y2="12.7"/></svg>`

  //pull relevant variables from bill
  let { bill_number, status_id, body_id, current_body_id,  non_originating_id, merged_bill, pending_committee_id, dead_bill } = bill
  
  // make sure everything that should be a number is a number
  status_id = parseFloat(status_id); body_id = parseFloat(body_id); current_body_id = parseFloat(current_body_id); pending_committee_id = parseFloat(pending_committee_id); non_originating_id = parseFloat(non_originating_id);
  // console.log(bill_number, body_id, non_originating_id, current_body_id)

  // pull out chamber name variables for this market
  const { sldu: secondChamber, sldl: firstChamber, lower_id: firstChamberId, upper_id: secondChamberId} = chamberNames[MARKET_KEY]
  
  // identify originating and non-originating chambers for this bill using legiscan body_id
  let originating_chamber = ''
  let non_originating_chamber = ''
  if (body_id == firstChamberId) {
    originating_chamber = firstChamber
    non_originating_chamber = secondChamber
  } else { 
    originating_chamber = secondChamber
    non_originating_chamber = firstChamber
  }

  // overwrite filler text for each step according to bill's status/origin
  function replacer(str, label) {
    // override step for governor's desk with passed/vetoed
    let gov_text = 'Governor’s Desk'
    let gov_description = ''
    let gov_sentence = ''
    if (status_id == 4) {
      gov_text = passed['label']
      gov_description = passed['description']
      gov_sentence = passed['sentenceLabel']
    } else if (status_id == 5) {
      gov_text = vetoed['label']
      gov_description = vetoed['description']
      gov_sentence = vetoed['sentenceLabel']
    }
    return str
      .replace('%ORIGINATING_CHAMBER%', originating_chamber)
      .replace('%NON_ORIGINATING_CHAMBER%', non_originating_chamber)
      .replace('%FIRST_CHAMBER_ID%', firstChamberId)
      .replace('%ORIGINATING_ID%', body_id)
      .replace('%NON_ORIGINATING_ID%', non_originating_id)
      .replace('%GOV_PRONOUN%', 'he/she/they')
      .replace('%GOV_TEXT%', gov_text)
      .replace('%GOV_DESCRIPTION%', gov_description)
      .replace('%GOV_SENTENCE%', gov_sentence)
      // .replace(/(.*)/, ':D')
  }

  let STEPS = updated_bill_steps.map(function(d) {

    return (
      {...d,
      status: +d.status,
      chamber: replacer(d.chamber, d.label),
      label: replacer(d.label, d.label),
      sentenceLabel: (dead_bill && d.deadSentenceLabel) ? replacer(d.deadSentenceLabel, d.label) : (merged_bill && d.mergedSentenceLabel) ? replacer(d.mergedSentenceLabel, d.label) : replacer(d.sentenceLabel, d.label),
      description:  (dead_bill && d.deadDescription) ? replacer(d.deadDescription, d.label) : (merged_bill && d.mergedDescription) ? replacer(d.mergedDescription, d.label) : replacer(d.description, d.label)}
    )
  })
  //boolean flags for committee status
  let orig_in_committee = pending_committee_id > 0 && current_body_id == body_id;
  let non_orig_in_committee = pending_committee_id > 0 && current_body_id == body_id;
  if (orig_in_committee) {
    if (MARKET_KEY == 'CT') { // show in committee for both chambers for CT
      STEPS = STEPS.filter(s => s.filter != 'orig_introduced' && s.filter != 'non_orig_introduced')
    } else {
      STEPS = STEPS.filter(s => s.filter != 'orig_introduced' && s.filter != 'non_orig_committee')
    }
  } else if (non_orig_in_committee) {
    if (MARKET_KEY == 'CT') { // show in committee for both chambers for CT
      STEPS = STEPS.filter(s => s.filter != 'orig_introduced' && s.filter != 'non_orig_introduced')
    } else {
      STEPS = STEPS.filter(s => s.filter != 'non_orig_introduced' && s.filter != 'orig_committee')
    }
  } else {
    STEPS = STEPS.filter(s => s.filter != 'orig_committee' && s.filter != 'non_orig_committee')
  }
  // console.log(STEPS)
  STEPS = STEPS.sort((a, b) => a.chamber-b.chamber) // sort so first chamber is first

  // remove further review steps unless relevant for that bill
  if (status_id != 3.5) {
    STEPS = STEPS.filter( s => s.status != 3.5)
  }

  // pull out just labels from the steps and remove duplicates - for making the table
  let labels = STEPS.map((s) => s.label).filter((x, i, a) => a.indexOf(x) == i)
  // console.log(labels)

  // find current bill label for autotext
  let currentLabels = STEPS.find((s) => s.status === status_id && parseInt(s.chamber) === current_body_id)
  if (!currentLabels) {
    // it would fail to find a label if status_id = 5 (vetoed); manually override w/ the governor's desk step
    currentLabels = STEPS.find((s) => s.status === 4)
  }

  // function to generate relevant styles for each step in the table depending on where the bill is in the process 
  // chamber = columns, label = rows
  function getCellContent(chamber, label) {

    // pull out the step for this cell 
    const S = STEPS.find((s) => s.chamber == chamber && s.label == label)

    //only run if it can find a valid step
    if (S) {

      // initiate classes for styling the cell
      let this_class = '' 
      let arrow_class = ''
      let highlight_arrow = ''
      let further_review_highlight_arrow = ''

      //// shade past status
      // highlight previous steps in current chamber
      if ( S.status < status_id && S.chamber == current_body_id) {
        this_class = progressStyles.pastProgressCell
      }
      // if it has passed to next chamber, highlight all steps in previous chamber
      if (body_id != current_body_id && status_id > 1 && S.chamber == body_id) {
        this_class = progressStyles.pastProgressCell
      }
      // if bill has reached the governor, highlight all previous steps
      if (status_id >= 4 && S.status < 4) {
        this_class = progressStyles.pastProgressCell
      }
      if (status_id == 3 && current_body_id == body_id && S.status < 4 ) {
        this_class = progressStyles.pastProgressCell;
      }
      // highlight non-orig chamber steps for orig chamber furhter review
      if (status_id == 3.5 && body_id == current_body_id && S.chamber == non_originating_id && S.status < 3.5) {
        this_class = progressStyles.pastProgressCell
      }

      //// generate process arrows
      // style down facing arrows on relevant cells - all except passed in orig chamber, which gets diagonal arrow below
      if (S.status < 2 && S.chamber == body_id || S.chamber == non_originating_id && S.status < 4) {
        arrow_class =  progressStyles.down
      }
      // originating chamber passed status gets arrow going up and over to other chamber introduced status
      if (S.status == 2 && S.chamber == body_id) {
        if (non_originating_id == secondChamberId) {
          arrow_class = progressStyles.diagonalLeft
        } else if (non_originating_id == firstChamberId) {
          arrow_class = progressStyles.diagonalRight
        }
      }
      // put bottom border on passed cells if further review is active
      if (S.label == 'Passed' && status_id == 3.5) {
        arrow_class = progressStyles.furtherReviewPassed;
      }

      ////higlight current status  - legislature steps 
      if (status_id == S.status && current_body_id == S.chamber) {
        this_class = progressStyles.highlightProgressCell
      }
      // highlight both committees for CT
      if (MARKET_KEY == 'CT' && pending_committee_id) {
        console.log('ct in committee', status_id)
        if ((status_id == 1 && S.status == 2 && S.chamber == non_originating_id) || (status_id == 2 && S.status == 1 && S.chamber == body_id)) {
          this_class = `${progressStyles.ctJointCommitteeHighlight} ${progressStyles.highlightProgressCell}`
        }
      }
      // highlight current status - governor steps
      if ((S.status == 4 && status_id >= 4)) {
        if (status_id == 4) {
          this_class = `${progressStyles.highlightProgressCell} ${progressStyles.passed}`
        } else if (status_id == 5) {
          this_class = `${progressStyles.highlightProgressCell} ${progressStyles.vetoed}`
        }
      } else if (S.status == 4 && status_id < 4) {
        this_class = `${progressStyles.governor}`
      }
      // highlight governor's desk if it's enrolled but is no longer in non-orig chamber
      if (status_id == 3 && current_body_id == body_id && S.status == 4 ) {
        this_class = progressStyles.highlightProgressCell;
      }
      //highlight diagonal arrow when orig chamber passed or orig chamber further review is highlighted
      if (current_body_id == body_id) {
        if (status_id == 2) {
          highlight_arrow = progressStyles.highlightArrow;
        } else if (status_id == 3.5) {
          further_review_highlight_arrow = progressStyles.highlightArrow;
        }
        
      }

      // // handle bill going back to originating chamber after passing the other one - further review
      // if (status_id == 3.5) {
      //   if (S.status < 4 ) { // all non-governor cells have been passed
      //     this_class = progressStyles.pastProgressCell
      //   }
      //   if (S.status == 2 && S.chamber == body_id && current_body_id == S.chamber) { // highlight returning to originating chamber 
      //     this_class = progressStyles.highlightProgressCell
      //     S.label = 'Further Review'
      //   } else if (S.status == 3 && S.chamber == non_originating_id && current_body_id == S.chamber) { // highlight return ing to non-originating chamber
      //     this_class = progressStyles.highlightProgressCell
      //     S.label = 'Further Review'
      //   }
      // }

      return (
        <Fragment>
            {/* generate cell w/dynamic styles -  if it is gov cell it should span the whole table width */}
            <td colspan={S.status > 3.5 ? '3' : ''} className={`${this_class} ${arrow_class} ${(dead_bill || merged_bill) && progressStyles.deadBill}`}>
              <span>{S.display_label ? S.display_label : S.label}</span>
            </td>
            
            {/* add an extra cell for diagonal arrow */}
            { ( body_id == firstChamberId && S.status == 1 && S.chamber == firstChamberId ) && (<td rowspan={'2'} className={`${progressStyles.arrow} ${highlight_arrow} ${ minimal ? progressStyles.minimal : ''} ${(dead_bill || merged_bill) && progressStyles.deadBill}`}><div className={progressStyles.arrowContainer} dangerouslySetInnerHTML={{ __html: arrow_svg }}></div></td>) }
            { ( body_id == secondChamberId && S.status == 2 && S.chamber == firstChamberId ) && (<td rowspan={'2'} className={`${progressStyles.arrow} ${highlight_arrow} ${ minimal ? progressStyles.minimal : ''} ${progressStyles.rightLeft} ${(dead_bill || merged_bill) && progressStyles.deadBill}`}><div className={progressStyles.arrowContainer} dangerouslySetInnerHTML={{ __html: arrow_svg }}></div></td>) }
            
            {/* add an extra cell for further review arrow */}
            {(body_id == firstChamberId && S.status == 3.5 && status_id == 3.5 && S.chamber == firstChamberId) && <td className={`${progressStyles.arrow} ${further_review_highlight_arrow} ${ minimal ? progressStyles.minimal : ''}  ${(dead_bill || merged_bill) && progressStyles.deadBill}`} style={{border: 'none'}}><div className={progressStyles.arrowContainer} dangerouslySetInnerHTML={{ __html: further_review_arrow_svg }}></div></td>}
            {(body_id == secondChamberId && S.status == 3.5 && status_id == 3.5 && S.chamber == firstChamberId) && <td className={`${progressStyles.arrow} ${further_review_highlight_arrow} ${ minimal ? progressStyles.minimal : ''}  ${(dead_bill || merged_bill) && progressStyles.deadBill} ${progressStyles.rightLeft}`} style={{border: 'none'}}><div className={progressStyles.arrowContainer} dangerouslySetInnerHTML={{ __html: further_review_arrow_svg }}></div></td>}
        </Fragment>
      
      )
    }
  }

  return (
    <div
      className={`${progressStyles.container} ${
        minimal ? progressStyles.minimal : ''
      }`}
    >
      {!minimal && (
        <div className={progressStyles.text}>
          <p>
            This bill {currentLabels.readableLabel}
            <span className={`${progressStyles.highlight} ${dead_bill || merged_bill && progressStyles.deadBill} ${status_id == 5 && progressStyles.vetoed} ${status_id == 4 && progressStyles.passed}`}>
              {currentLabels.sentenceLabel}
            </span>
            . This means {currentLabels.description}.
          </p>
        </div>
      )}
      <table className={progressStyles.progressTable}>
        <tr>
          <th className={progressStyles.head}>{firstChamber}</th>
          <th className={`${progressStyles.arrow} ${ minimal ? progressStyles.minimal : ''}`}></th>
          <th className={progressStyles.head}>{secondChamber}</th>
        </tr>
        {/* generate step cells using function above - chamber = coluns labels = rows */}
        {labels.map((l, i) => (
          <tr key={i}>{[firstChamberId, secondChamberId].map((c, i) => getCellContent(c, l))}</tr>
        ))}
      </table>
    </div>
  )
}

export default Progress
